export const deliveryWebhook = {
  payload: `{
  "order_id": "629f2fe68fc53a6e738b0dbc",
  "display_book_id": "WD-1001",
  "status": "ACCEPT",
  "amount": "KWD 1.750",
  "order_number": "1321",
  "order_details": "PIZZA",
  "payment_type": "COD",
  "cod_amount": "50.99",
  "branch_id": "1d3c05a0-cf57-11ec-b00f-65a3fce43a38",
  "customer_info": [
    {
      "name": "Jack",
      "country_code": "+965",
      "phone": "1234567890",
      "email": "jack@example.com"
    }
  ],
  "pick_info": {
    "lat": "29.3326",
    "long": "48.0719",
    "address": "Salmiya Branch"
  },
  "drop_info": {
    "lat": "29.3759",
    "long": "47.9774",
    "address": "Kuwait City, Kuwait"
  },
  "driver_info": [
    {
      "name": "Driver Name",
      "country_code": "+965",
      "phone": "98765432",
      "email": "",
      "location": {
        "latitude": 29.34,
        "longitude": 48.05
      }
    }
  ],
  "vehicle_info": [
    {
      "car": "Bike",
      "model": "NMAX",
      "brand": "Yamaha",
      "color": "Black",
      "license_plate": "ABC 123"
    }
  ]
}`,
  payloadFields: [
    { field: "order_id", type: "string", desc: "Internal order ID" },
    { field: "display_book_id", type: "string", desc: "Display / reference order ID" },
    { field: "status", type: "string", desc: "Current order status (see status values)" },
    { field: "amount", type: "string", desc: "Delivery amount with currency" },
    { field: "order_number", type: "string", desc: "Your POS / external order number" },
    { field: "order_details", type: "string", desc: "Items / notes for the driver" },
    { field: "customer_info", type: "array", desc: "Customer name, phone, email" },
    { field: "pick_info", type: "object", desc: "Restaurant / branch lat/long/address" },
    { field: "drop_info", type: "object", desc: "Customer drop lat/long/address" },
    { field: "driver_info", type: "array", desc: "Driver details + live location after accept" },
    { field: "vehicle_info", type: "array", desc: "Vehicle type/model/brand/color/plate" },
    { field: "branch_id", type: "string", desc: "Pickup branch ID" },
  ],
  statusValues: [
    { status: "PENDING", meaning: "Order created, waiting" },
    { status: "SEARCHING", meaning: "Looking for a driver" },
    { status: "ASSIGN", meaning: "Assigned to a driver" },
    { status: "UNASSIGN", meaning: "Driver unassigned" },
    { status: "ACCEPT", meaning: "Driver accepted" },
    { status: "ARRIVED AT RESTAURANT", meaning: "Driver arrived at the branch" },
    { status: "ONROUTE", meaning: "On the way to the customer" },
    { status: "ARRIVED AT CUSTOMER", meaning: "Driver arrived at drop" },
    { status: "COMPLETED", meaning: "Order delivered" },
    { status: "CANCELLED", meaning: "Order cancelled" },
  ],
  credentials: [
    { item: "web_hook_url", desc: "Your webhook endpoint URL (registered in Authorize)" },
    { item: "webhook_secure_key", desc: "Shared secret used to sign/verify the payload" },
    { item: "Signature header", desc: "Usually x-secure-signature (confirm with Wiyak support if unsure)" },
  ],
};
